import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({
  // 👇 只改这里！！！
  mode: 'hash', // 用 hash 模式 → 双击 dist 直接打开
  base: './',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router